// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"51ddefeb","239":"a825d90a","732":"dd51ad71"}[chunkId] + ".chunk.js";
};